import { Editor } from '@tinymce/tinymce-react';
import { Button } from 'semantic-ui-react';
import  { useState, useRef, useEffect } from "react";



// takes data, number, callback
const UpdateEditor = ({data, callback}) => {
    const editorRef = useRef(null);
    const [editor, setEditor] = useState(data)
    const [loading, setLoading] = useState(false)
    
    const returnMessage = () => {
        setLoading(true);
        callback(editorRef.current.getContent())
        setEditor("")
        setTimeout(() => setLoading(false), 1000)
    }
    return (<>
        <Editor
            onInit={(evt, editor) => editorRef.current = editor}
            init={{
                license_key:"gpl",
                menubar: false,
                relative_urls: true,
                browser_spellcheck: true,
                paste_data_images: true,
                plugins: [
                    'advlist autolink lists link charmap template image print preview pagebreak anchor',
                    'searchreplace visualblocks code importcss emoticons',
                    'insertdatetime media table paste code help codesample wordcount'
                ],
                toolbar: 'undo redo |'+ 
                ' bold italic underline forecolor | alignleft aligncenter '+ 
                'alignright alignjustify |link image table | numlist bullist | '+
                '|  code | fontsizeselect formatselect ',
                fontsize_formats:"8pt 9pt 10pt 11pt 12pt 14pt 18pt 20pt 24pt 26pt 28pt 30pt 32pt 34pt 36pt ",
                extended_valid_elements:[
                    'table[border=1 | class=tiny-table]'
                ],
                pagebreak_separator:`<div class="new-page" ></div>`,
            }}
            value={editor}
            onEditorChange={(value)=>setEditor(value)}
            />
        <Button type="button" loading={loading} onClick={() => returnMessage()}>Submit</Button>
    </>)
}

export default UpdateEditor

